export default __webpack_public_path__ + "static/media/green-bullet.58a0ebcb.svg";